module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "continued"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('h5', [_vm._v("持续刷新 永不毕业")]), _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("会员申请"), _c('div', {
    staticClass: "triangle-right"
  })])]), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("一个持续刷新的「学习机制」"), _c('br'), _vm._v("\n全球TOP 20学府权威前沿学者的顾问团和科研网络"), _c('br'), _vm._v("\n世界级科技公司顶层资源和交流机制"), _c('br'), _vm._v("\n中国优秀创业公司创始人的群落和有效率的沟通"), _c('br'), _vm._v("\n极客公园对产业趋势的专业判断和全球资源能力"), _c('br'), _vm._v("\n每年引导最有价值的主题和人，创造持续的交流价值")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72d8b8e2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterUser.vue
// module id = 208
// module chunks = 1